import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

const format = 'dd/MM/yyyy';

const StyledDatePicker = withStyles((theme: Theme) => {
  return {
    root: {
      '& > div': {
        // [theme.breakpoints.up('sm')]: {
        //   width: 400,
        // },
        '& .Mui-disabled': {
          color: theme.palette.action.disabled,
        },
      },
    },
  };
})((props: any) => <DesktopDatePicker {...props} inputFormat={format} renderInput={(params: any) => <TextField {...params} variant="standard" />} />);

export default StyledDatePicker;
